module.exports = __webpack_public_path__ + "static/vela-logo-967627431fed1f58d57f0e00c5b848fe.png";